import { useQuery } from '@tanstack/react-query';
import { env } from '@/utils/envs';
import QueryKey from '@/utils/queryKeys';

export type RewardsLeaderboardEntry = {
  identity: string | null;
  displayName?: string;
  points: number;
};

type LeaderboardResponse = {
  leaderboard?: RewardsLeaderboardEntry[];
};

async function fetchRewardsLeaderboard(): Promise<RewardsLeaderboardEntry[]> {
  const response = await fetch(
    `${env.VITE_SHINKAI_WEB_API_URL}/api/rewards/leaderboard`,
  );
  if (!response.ok) {
    throw new Error('Failed to fetch leaderboard');
  }
  const data = (await response.json()) as LeaderboardResponse;
  return data.leaderboard ?? [];
}

/**
 * Fetches the rewards leaderboard from /api/rewards/leaderboard.
 *
 * Returns a sorted-ready array of `RewardsLeaderboardEntry`.
 * Shared across HomePage, LeaderboardPage, IdentityPage, and
 * IdentityInfoTabContent so every consumer shares a single cache entry.
 */
export const useRewardsLeaderboard = () => {
  return useQuery({
    queryKey: [QueryKey.REWARDS_LEADERBOARD],
    queryFn: fetchRewardsLeaderboard,
    staleTime: 60_000,
  });
};
